function initDeliveryAccordions(scope = document) {
  const accordions = scope.querySelectorAll('[data-delivery-accordion]');

  accordions.forEach(accordion => {
    if (accordion.dataset.accordionInitialized === 'true') return;
    accordion.dataset.accordionInitialized = 'true';

    const items = Array.from(accordion.querySelectorAll('.delivery-accordion__item'));

    function closeItem(item) {
      const button = item.querySelector('.delivery-accordion__button');
      const content = item.querySelector('.delivery-accordion__content-wrap');
      if (!button || !content) return;
      item.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      content.style.maxHeight = '0px';
      content.setAttribute('hidden', 'hidden');
    }

    function openItem(item) {
      const button = item.querySelector('.delivery-accordion__button');
      const content = item.querySelector('.delivery-accordion__content-wrap');
      if (!button || !content) return;
      item.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      content.removeAttribute('hidden');
      content.style.maxHeight = `${content.scrollHeight}px`;
    }

    // Ensure all items are closed on initial page load.
    items.forEach(closeItem);

    items.forEach(item => {
      const button = item.querySelector('.delivery-accordion__button');
      const content = item.querySelector('.delivery-accordion__content-wrap');

      button.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        items.forEach(closeItem);
        if (!isOpen) openItem(item);
      });

      // Recompute max-height only for this accordion item.
      if (content) {
        content.style.maxHeight = item.classList.contains('is-open') ? `${content.scrollHeight}px` : '0px';
      }
    });

    window.addEventListener('resize', () => {
      const openItemNode = accordion.querySelector('.delivery-accordion__item.is-open .delivery-accordion__content-wrap');
      if (openItemNode) {
        openItemNode.style.maxHeight = `${openItemNode.scrollHeight}px`;
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initDeliveryAccordions(document), { once: true });
} else {
  initDeliveryAccordions(document);
}

document.addEventListener('shopify:section:load', event => {
  initDeliveryAccordions(event.target);
});
